import moment, { Moment } from 'moment';

/**
 * Converts a given date (string or Date) to a Moment object.
 * If no date is provided, returns an invalid Moment.
 */
export const toMoment = (date?: string | Date): Moment =>
  date == null
    ? moment()
    : typeof date === 'string'
      ? date.trim()
        ? moment(date.trim(), moment.ISO_8601, true)
        : moment.invalid()
      : moment(date);

export const getStartOfDay = (): Date | string => {
  return new Date(moment().startOf('day').format('YYYY-MM-DDT00:00:00.000'));
};

export const getEndOfDay = (): Date | string => {
  return new Date(moment().format('YYYY-MM-DDT23:59:59.000'));
};

export const getCurrentDateTimeISO = (): string => {
  return moment().format('YYYY-MM-DDTHH:mm:ss.SSS');
};

/**
 * Formats a given date (string or Date) to ISO 8601 format (YYYY-MM-DDTHH:mm:ssZ).
 * @param date
 * @returns
 */
export const formatDateToISO = (date?: string | Date): string => {
  return !date ? '' : moment(date).utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
};

export const formatDateTimeLabel = (date?: string | Date): string => {
  return !date ? ' ' : moment(date).format('YYYY-MM-DD HH:mm:ss');
};

export const formatDateTimeNSecLabel = (date?: string | Date): string => {
  return !date ? '' : moment(date).format('YYYY-MM-DD HH:mm');
};

export const formatTimeNSecLabel = (date?: string | Date): string => {
  return !date ? '' : moment(date).format('HH:mm');
};

export const formatDateLabel = (date?: string | Date): string => {
  return !date ? '' : moment(date).format('YYYY-MM-DD');
};

export const parseServerDate = (dayNum: number | string): Moment => {
  const str = String(dayNum);
  if (!/^\d{8}$/.test(str)) return moment.invalid();
  const year = Number(str.slice(0, 4));
  const month = Number(str.slice(4, 6)) - 1;
  const day = Number(str.slice(6, 8));
  return moment({ year, month, day });
};

export const getShortWeekday = (day: number | string): string => {
  const dayStr = String(day);
  if (!/^\d{8}$/.test(dayStr)) return '';

  const year = Number(dayStr.slice(0, 4));
  const month = Number(dayStr.slice(4, 6)) - 1;
  const date = Number(dayStr.slice(6, 8));

  return moment(new Date(year, month, date)).format('ddd');
};

export const formatServerDate = (dayNum: number | string): string => {
  const m = parseServerDate(dayNum);
  return m.isValid() ? m.format(`YYYY/MM/DD`) : '';
};
